import { colors } from '@tabbio/tokens';
import { ProIcon } from '../icons/ProIcon';

export function SubscriptionPlanBadge({ label }: { label: string }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        color: colors.brandViolet,
        fontSize: 20,
        fontWeight: 700,
      }}
    >
      <ProIcon size={24} boxed={false} />
      {label}
    </span>
  );
}
